import { ComponentPropsWithoutRef, FC } from "react";

type LogoProps = {} & ComponentPropsWithoutRef<"div">;

// Renders the Klap wordmark.
//
// Previously used `<ReactSVG>` which fetches the SVG over XHR and injects it
// into the DOM after JS hydration. That left the top-left logo slot empty for
// the first ~50–200ms of every page load — a visible "paint flash" against
// the white header on `/`.
//
// We now render a plain `<img>` so the browser can fetch and rasterize the
// SVG synchronously while parsing the HTML — no JS dependency, no flash.
//
// The wordmark is monochrome (no explicit `fill` in the SVG → defaults to
// black). When the header flips to its dark variant on scroll
// (`<Header className="bg-slate-950 dark">`), `dark:invert` flips the black
// pixels to white, matching the previous `fill-slate-950 dark:fill-white`
// behavior without needing two image variants.
const Logo: FC<LogoProps> = ({ ...rest }) => {
  return (
    <div
      {...rest}
      className={`${rest.className ?? ""} h-auto flex gap-2 items-center w-20`}
    >
      <img
        src="/svg/Klap_logo.svg"
        alt="Klap logo"
        width={270}
        height={108}
        className="w-full h-auto shrink-0 dark:invert"
      />
    </div>
  );
};

export default Logo;
